var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab d-flex flex-column"},[_c('h5',{staticClass:"i_mt_1 i_mt_sm_0"},[_vm._v(_vm._s(_vm.tab))])])}
var staticRenderFns = []

export { render, staticRenderFns }